import { useState, useEffect } from "react";
import t from "prop-types";
import CommonDialog from "./material_ui/Dialog";
import BigWarning from "@amplio-common/assets/svgs/big-i-warning.svg";
import { FormControlLabel, Checkbox } from "@material-ui/core";
import { Trans } from "@lingui/macro";


import { css } from "@emotion/react";
import theme from "@app/theme";
import { trackEvent } from "@amplio-common/analytics";

const propTypes = {
  cancelAction: t.func,
  showDontShowAgain: t.bool,
};


const rootStyle = css`
  > img {
    height: 160px;
    display: block;
    margin: 0 auto;
  }

  > button {
    border: 0;
    background: none;
    padding: 0;
    cursor: pointer;
    color: ${theme.amplioColor};
    outline: none;
    &:hover { text-decoration: underline; }
  }

  > h4 { margin-bottom: 0px; }
  > ul { margin-top: 5px; }
`;

// localStorage[
export const LOCAL_STORAGE_DONT_SHOW_WEAK_CPU_DIAG = "dont-show-weak-cpu-diag";

const WeakCPUDiag = (props) => {
  const { cancelAction, showDontShowAgain } = props;
  const [isReadMore, setIsReadMore] = useState(false);
  const [isNeverShowAgainChecked, setIsNeverShowAgainChecked] = useState(false);

  useEffect(() => {
    trackEvent("view_unsupported_device_dialog", {});
  }, []);

  return (
    <CommonDialog
      open
      maxWidth="md"
      title="Important Message"
      cancelAction={cancelAction}
      cancelLabel="Ok, I understand"
      leftSideAction={showDontShowAgain ? (
        <FormControlLabel
          style={{ marginRight: 0, background: "transparent" }}
          label="Don't show again"
          control={(
            <Checkbox
              checked={isNeverShowAgainChecked}
              color="primary"
              onChange={() => {
                localStorage.setItem(LOCAL_STORAGE_DONT_SHOW_WEAK_CPU_DIAG, !isNeverShowAgainChecked);
                setIsNeverShowAgainChecked(!isNeverShowAgainChecked);
              }}
            />
              )}
        />
      ) : undefined}
      content={(
        <div css={rootStyle}>
          <img src={BigWarning} alt="" />
          We have detected that the device you are using may not provide the best experience with AmplioSpeech.<br />
          To take full advantage of the AmplioSpeech platform and our rich library of multimedia content, we strongly recommend that you use a different device.<br />
          Here’s a list of the minimum requirements for the best experience:
          <br />
          {!isReadMore && <button type="button" onClick={() => setIsReadMore(true)}><Trans>Read more...</Trans></button> }
          {
            isReadMore && (
              <>
                <h4>Computer</h4>
                <ul>
                  <li>Dual core processor i3-5010U and above <br />(Chromebooks with intel Celeron CPU are not supported)</li>
                  <li>4 GB RAM</li>
                  <li>1 inch display or larger</li>
                  <li>Playback device (i.e. build-in or external speakers, headphones, etc.)</li>
                  <li>Web cam</li>
                  <li>Fast internet connection</li>
                </ul>

                <h4>Browser and Operating System</h4>
                <ul>
                  <li>Latest Version of Google Chrome or Edge</li>
                  <li>Windows 10, Mac OS X 10.13 (or later)</li>
                </ul>
              </>
            )
          }
        </div>
      )}
    />
  );
};

WeakCPUDiag.propTypes = propTypes;

export default WeakCPUDiag;
